module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainProduct__btnWrap"
  }, [_c('a', {
    staticClass: "mainProduct__btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToCard.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    add to cart\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa10be0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainBtn.vue
// module id = 49
// module chunks = 0